"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isViewMandatory = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
function isViewMandatory(view, self) {
    var _a, _b;
    if (view.type === DataType_1.default.OP)
        return ((_a = self.settings) === null || _a === void 0 ? void 0 : _a.mandatoryOpsLogLmssIds.indexOf(view.id)) >= 0;
    if (view.type === DataType_1.default.ISSUE)
        return ((_b = self.settings) === null || _b === void 0 ? void 0 : _b.mandatoryIssuesLogLmssIds.indexOf(view.id)) >= 0;
    if (view.type === DataType_1.default.OPDEFINITION)
        return view.id === DataType_1.default.OPDEFINITION;
    return false;
}
exports.isViewMandatory = isViewMandatory;
exports.default = isViewMandatory;
